export default __webpack_public_path__ + "static/media/rotation.1fb64853.svg";